var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body border rounded mb-4",class:_vm.theme == 'light' ? 'bg-white' : 'border-info'},[_c('div',{staticClass:"row"},[_vm._m(0),_c('div',{staticClass:"col-sm-2 mb-2 text-right pl-1"},[_c('div',{staticClass:"row px-3"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.malwareReportInterval),expression:"malwareReportInterval"}],staticClass:"form-control",attrs:{"id":"exampleFormControlSelect1"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.malwareReportInterval=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.getMalwareReports]}},[_c('option',{attrs:{"value":"7d"}},[_vm._v(_vm._s(_vm.$t("malware.last-7")))]),_c('option',{attrs:{"value":"30d"}},[_vm._v(_vm._s(_vm.$t("malware.last-30")))]),_c('option',{attrs:{"value":"3m"}},[_vm._v(_vm._s(_vm.$t("malware.last-90")))])])])])]),_c('GmapMap',{ref:"mymap",staticClass:"maps",attrs:{"center":_vm.center,"zoom":_vm.zoom,"options":_vm.mapTheme()},on:{"click":_vm.measureDistance}},[_c('div',{ref:"custom",staticClass:"mr-2"},[_c('button',{staticClass:"btn btn-white btn-sm py-2 mb-2",class:_vm.measure_distance == true ? 'bg-info' : 'bg-white',attrs:{"title":"Measure Distance"},on:{"click":function($event){return _vm.distanceMode()}}},[_c('img',{attrs:{"src":"https://img.icons8.com/external-those-icons-lineal-color-those-icons/24/000000/external-distance-maps-and-locations-those-icons-lineal-color-those-icons-2.png"}})]),_c('br'),_c('button',{staticClass:"btn btn-white btn-sm py-2 bg-white",attrs:{"title":"Point of Interest"},on:{"click":function($event){return _vm.poiView()}}},[_c('img',{attrs:{"src":_vm.poi == true
              ? 'https://img.icons8.com/glyph-neue/24/24991f/point-of-interest.png'
              : 'https://img.icons8.com/glyph-neue/24/525252/point-of-interest.png'}})])]),(_vm.firstpoint.on == true)?_c('GmapMarker',{ref:"first_point",attrs:{"label":{
        text: '0 km',
        color: _vm.theme == 'dark' ? '#e5e7eb' : '#000000',
        fontWeight: 'bold',
      },"clickable":true,"options":{
        position: {
          lat: parseFloat(_vm.firstpoint.lat),
          lng: parseFloat(_vm.firstpoint.lng),
        },
      },"icon":{
        url:
          _vm.theme == 'dark'
            ? 'https://img.icons8.com/windows/30/e5e7eb/wind-speed-less-1.png'
            : 'https://img.icons8.com/windows/30/000000/wind-speed-less-1.png',
        width: 50,
        height: 50,
        textSize: 12,
        anchor: { x: 14, y: 16 },
        labelOrigin: { x: 5, y: -5 },
      }},on:{"click":function($event){return _vm.unsetDistanceMarker('first')}}}):_vm._e(),(_vm.secondpoint.on == true)?_c('GmapMarker',{ref:"second_point",attrs:{"label":{
        text: _vm.distance + ' km',
        color: _vm.theme == 'dark' ? '#e5e7eb' : '#000000',
        fontWeight: 'bold',
      },"clickable":true,"options":{
        position: {
          lat: parseFloat(_vm.secondpoint.lat),
          lng: parseFloat(_vm.secondpoint.lng),
        },
      },"icon":{
        url:
          _vm.theme == 'dark'
            ? 'https://img.icons8.com/windows/30/e5e7eb/wind-speed-less-1.png'
            : 'https://img.icons8.com/windows/30/000000/wind-speed-less-1.png',
        width: 50,
        height: 50,
        textSize: 12,
        anchor: { x: 16, y: 16 },
        labelOrigin: { x: 5, y: -5 },
      }},on:{"click":function($event){return _vm.unsetDistanceMarker('second')}}}):_vm._e(),(_vm.firstpoint.on == true && _vm.secondpoint.on == true)?_c('GmapPolyline',{attrs:{"options":{
        strokeColor: _vm.theme == 'dark' ? '#9ca3af' : '#212121',
        strokeOpacity: 0.8,
        strokeWeight: 3,
      },"path":[
        { lat: _vm.firstpoint.lat, lng: _vm.firstpoint.lng },
        { lat: _vm.secondpoint.lat, lng: _vm.secondpoint.lng } ],"editable":false}}):_vm._e(),_vm._l((_vm.detection),function(mp,index){return _c('GmapMarker',{key:index,attrs:{"clickable":true,"options":{
        position: {
          lat: parseFloat(mp.position.lat),
          lng: parseFloat(mp.position.lng),
        },
      },"icon":{
        url: require('@/assets/images/dot-point.png'),
        width: 500,
        height: 500,
        textSize: 12,
        anchor: { x: 16, y: 16 },
        labelOrigin: { x: 5, y: -5 },
      }},on:{"click":function($event){_vm.openMarker(
          index + 1,
          parseFloat(mp.position.lat),
          parseFloat(mp.position.lng),
          20
        )}}},[_c('gmap-info-window',{attrs:{"closeclick":true,"opened":_vm.openMarkerId === index + 1},on:{"closeclick":function($event){_vm.openMarker(
            null,
            parseFloat(mp.position.lat),
            parseFloat(mp.position.lng),
            15
          )}}},[_c('div',{staticClass:"p-2"},[_c('h4',{staticClass:"text-success"},[_vm._v(" "+_vm._s(mp.country)+" ")]),_c('div',{staticClass:"text-info border border-danger p-1 rounded"},[_c('h6',{staticClass:"text-black mt-2 mx-2"},[_vm._v("Hits : "+_vm._s(mp.hits))])])])])],1)})],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-10 mb-1"},[_c('h5',[_c('b',[_c('i',{staticClass:"bx bx-map-pin mr-1"}),_vm._v(" Malware Detection")])])])}]

export { render, staticRenderFns }